import Service from '@/services/modules/contracts.service';

const add = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }, _filters) => {
    const response = Service.all(_filters.limit, _filters.currentPage, _filters.params, _filters.orderBy, _filters.orderDirection);

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const downloadFull = async({ commit }, _id) => {
    return Service.downloadFull(_id);
}

const edit = async({ commit }, _module) => {
    const response = Service.edit(_module.id, _module);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = Service.get(_id);

    response.then(function (_response) {
        console.log('-----------------------');
        console.log(_response);
        console.log('-----------------------');
        commit('setObject', _response);
    });

    return response;
};

const rem = async({ commit }, _module) => {
    const response = Service.rem(_module.id);

    return response;
};

const sendDocument = async({ commit }, _module) => {
    const response = Service.sendDocument(_module.id, _module);

    return response;
};

export default {
    add,
    all,
    downloadFull,
    edit,
    get,
    rem,
    sendDocument
};